<template>
  <div>
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          class="text-black"
          variant="text"
          data-cy="historyDialogDropdown"
          @focus="$event.target.blur()"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <HistoryMenuItems
        :passedinParameter="passedinParameter"
        :selectedDevices="selectedDevices"
        :permissions="permissions"
        @parameterChange="parameterChange"
        @openExportData="openExportData"
      />
    </v-menu>
    <ExportDataDialog
      :open="exportData"
      :devices="selectedDevices"
      :permissions="permissions"
      @close="closeExportData"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import type { WidgetDevice } from '@/helpers/widgets/helper'
import HistoryMenuItems from './HistoryMenuItems.vue'
import ExportDataDialog from '@/components/dialogs/ExportDataDialog.vue'

export default defineComponent({
  name: 'history-menu',
  props: {
    selectedDevices: { type: Array as PropType<WidgetDevice[]>, required: true },
    passedinParameter: Number,
    permissions: { type: Object as PropType<Record<string, string[]>>, required: true }
  },
  components: { HistoryMenuItems, ExportDataDialog },
  emits: ['parameterChange'],
  data() {
    return {
      exportData: false
    }
  },
  methods: {
    openExportData() {
      this.exportData = true
    },
    closeExportData() {
      this.exportData = false
    },
    parameterChange(selected: number) {
      this.$emit('parameterChange', selected)
    }
  }
})
</script>

<style lang="scss" scoped>
.v-card-title {
  .v-btn {
    padding: 0;
    min-width: 10px;
    padding-left: 0.4rem;
    padding-right: 0.4rem;

    .v-icon {
      font-size: 22px;
    }
  }
}
</style>
